// extracted by mini-css-extract-plugin
export default {"blue_btn":"Buttons_blue_btn__OQ2KK","blue_white_btn":"Buttons_blue_white_btn__hMXa6","white_btn":"Buttons_white_btn__TEWRs"};